// Almacén de marcas inerte, para los bloques que viven en DOS pantallas.
//
// `FacturasPedido` y `CargasPedido` los pintan la lista de pedidos y la pantalla
// de detalle, y en las dos se marcan filas —cada pantalla con su propio almacén—.
// Aun así su prop `marcas` es opcional, para poder montar el bloque sin almacén
// (un test, una pantalla futura) sin que el canalón aparezca a medias.
//
// Los hooks de React no son opcionales: `useMarcada` / `useMarcadas` tienen que
// llamarse siempre y en el mismo orden, haya almacén o no. Éste es el hueco que
// se les da cuando no lo hay: no guarda nada, no avisa a nadie y devuelve
// siempre el MISMO conjunto vacío, así que `useSyncExternalStore` —que compara
// por identidad— lo ve estable y no repinta jamás.
import type { MarcasFilas } from '@/types'

/** La misma instancia siempre: si se creara un `Set` nuevo en cada lectura,
 *  `useSyncExternalStore` lo tomaría por un cambio y entraría en bucle. */
const VACIO: ReadonlySet<string> = new Set()

export const SIN_MARCAS: MarcasFilas = {
  ambito: '',
  tiene: () => false,
  total: () => 0,
  todas: () => VACIO,
  alternar: () => {},
  quitar: () => {},
  limpiar: () => {},
  suscribir: () => () => {},
}
